import React from 'react'

const Footer = () => {
  return <>&copy; {new Date().getFullYear()} antegma GmbH - Hootsuite Integration is powered by ACCALLI/O Cloud</>
}

export default Footer
